import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateNotificationInAppMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationInAppInput;
}>;


export type UpdateNotificationInAppMutation = (
  { __typename?: 'Mutation' }
  & { updateNotificationInApp?: Types.Maybe<(
    { __typename?: 'UpdateNotificationInAppPayload' }
    & { notificationInApp: (
      { __typename?: 'NotificationInApp' }
      & Pick<Types.NotificationInApp, 'id' | 'objectId' | 'isRead'>
    ) }
  )> }
);


export const UpdateNotificationInAppDocument = gql`
    mutation updateNotificationInApp($input: UpdateNotificationInAppInput!) {
  updateNotificationInApp(input: $input) {
    notificationInApp {
      id
      objectId
      isRead
    }
  }
}
    `;
export type UpdateNotificationInAppMutationFn = Apollo.MutationFunction<UpdateNotificationInAppMutation, UpdateNotificationInAppMutationVariables>;

/**
 * __useUpdateNotificationInAppMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationInAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationInAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationInAppMutation, { data, loading, error }] = useUpdateNotificationInAppMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationInAppMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationInAppMutation, UpdateNotificationInAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationInAppMutation, UpdateNotificationInAppMutationVariables>(UpdateNotificationInAppDocument, options);
      }
export type UpdateNotificationInAppMutationHookResult = ReturnType<typeof useUpdateNotificationInAppMutation>;
export type UpdateNotificationInAppMutationResult = Apollo.MutationResult<UpdateNotificationInAppMutation>;
export type UpdateNotificationInAppMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationInAppMutation, UpdateNotificationInAppMutationVariables>;